import { KYMW2200Model } from '../kymw2200.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * メール送信
  *
 * @export
 * @class SendOCRDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SendOCRDataService extends PlessJsonResponderSub<any> {

  vo = {
    OrderCode: '',
    CatalogID: '',
    PrintCompany: '',
    MailAddress: '',
  };

  // 処理に使用するModel
  private model: KYMW2200Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SendOCRDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode,
        CatalogID: this.vo.CatalogID,
        PrintCompany: this.vo.PrintCompany,
        MailAddress: this.vo.MailAddress,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof SendOCRDataService
   */
  execute(model: KYMW2200Model, vo: any): void {
    this.model = model;
    this.vo = vo;
    this.send('sendOCRData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SendOCRDataService
   */
  success(data: any) {
  }
}
